export const localeRoot =
  "settings.paywalls.modal.tabs.pricing.add_price_modal.notice_v2";
